<template>
  <transition name="confirm-fade">
    <div v-if="isShowConfirm" class="my-confirm bj ub ub-pc ub-ac">
        <div class="box">
          <div class="city">
            <div class="dotted ub ub-ac ub-pc">
              <img class="photo" :src="photo_url" />
            </div>
       
            <div class="pulse1"></div>
            <div class="pulse2"></div>
            <div class="pulse3"></div>
            <div class="pulse4"></div>
          </div>
        </div>
    </div>
  </transition>
</template>

<script>
import * as tool from "../api/common";
import { mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
      arr: [],
      photo_url: "",
      sex: "男生",
      interval_id:''//循环播放控制标识
    };
  },
  computed: {
    uid_tag: function() {
      var uid = this.$store.state.uid;
      return uid;
    }
  },
  watch: {
    uid_tag(newVal, oldVal){
      var self = this;
      if (newVal) {
        setTimeout(() => {
          self.init();
        }, 300);
      }
    }
  },
  mounted() {
    var uid = this.$store.state.uid;
    if(uid){
      this.init();
    }
  },
  methods: {
    ...mapMutations(["get"]), //引入方法
    ...mapActions(["act_get_userinfo"]), //引入方法

    show() {
      var uid = this.$store.state.uid;
      var self = this;
        self.act_get_userinfo({
          uid: uid,
          success: function (u) {
            var sex = u.sex;
            self.sex = sex;
          },
        });

      this.isShowConfirm = true;
      this.play();
    },
    hidden() {
      this.isShowConfirm = false;
      clearInterval(this.interval_id);
    },

    init() {
      //当store中popup_matching_avatar没有数据时请求接口
      var popup_matching_avatar = this.$store.state.http_cache.popup_matching_avatar;
      var dtm = popup_matching_avatar.dtm;
      var search_sex = popup_matching_avatar.search_sex;
      if (dtm != '' && this.sex == search_sex) {
        this.arr = popup_matching_avatar.data_serve;
        return true;
      }

      var uid = this.$store.state.uid;
      var self = this;
        self.act_get_userinfo({
          uid: uid,
          success: function (u) {
            var sex = u.sex;
            self.sex = sex;
            self.init_arr(sex);
          },
        });

      
    },

    play() {
      var ii = tool.randomNum(0, 19);
      this.photo_url = this.arr[ii].photo1;

      var self = this;
      this.interval_id = setInterval(function () {
        var i = tool.randomNum(0, 19);
        self.photo_url = self.arr[i].photo1;
      }, 3000);
    },

    init_arr(sex){
      var search_sex = sex == "男生" ? "女生" : "男生";
      var self = this;

      this.get({
        url: "/App/GetPhoto/?count=" + 20 + "&sex=" + search_sex,
        success: function (data_serve) {
          var obj = {
            dtm: new Date().getTime(),
            search_sex: search_sex,
            data_serve: data_serve
          }
          self.$store.commit("set_http_cache", {popup_matching_avatar: obj});

          for (var i in data_serve) {
            data_serve[i].photo1 = self.$store.state.url + "/photo/" + data_serve[i].photo;
          }
          self.arr = data_serve;
        },
        error: function (err) {},
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.my-confirm {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 998;
  background-color: #2F2E33;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.confirm-fade-enter-active {
  animation: opacity 0.3s;
}

.confirm-fade-enter-active .confirm-content-wrap {
  animation: scale 0.3s;
}

.confirm-fade-leave-active {
  animation: outOpacity 0.2s;
}

@keyframes opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes scale {
}

@keyframes outOpacity {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.bj {
  background-image: url(../assets/img/new2024/bg-matching1.gif);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100vh;
}

.box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.photo2 {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
}

.photo {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  opacity: 0;
  z-index: 10;
  animation: fateimg1 3s ease-in-out infinite;
}

@keyframes fateimg1 {
  0% {
    opacity: 0;
    width: 0.1rem; //从小变大
    height: 0.1rem;
  }
  80% {
    opacity: 1;
    width: 5rem; //从小变大
    height: 5rem;
  }
  100% {
    opacity: 0.5;
    width: 2rem; //从小变大
    height: 2rem;
  }
}

.city {
  width: 30rem;
  height: 30rem;
  border-radius: 100%;
  position: relative;
  .dotted {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
  }
}
.city div[class^="pulse"] {
  /* 保证小盒子水平垂直居中 */
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 5rem;
  height: 5rem;
  box-shadow: 0 0 12px #82719e;
  border-radius: 50%;
  animation: pulse 5s linear infinite;
}
.city .pulse1 {
  animation-delay: 0s !important;
}

.city .pulse2 {
  animation-delay: 2s !important;
}

.city .pulse3 {
  animation-delay: 4s !important;
}

.city .pulse4 {
  animation-delay: 6s !important;
}

@keyframes pulse {
  0% {
    width: 5rem;
    height: 5rem;
  }

  100% {
    width: 30rem;
    height: 30rem;
    opacity: 1;
  }
}
</style>
